// Generated by scripts/build-ui-icons.mjs.
export { Plus as default } from "../ui/glyphs-6";
